module.exports = __webpack_public_path__ + "static/img/paixu03.93a7353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/paixu03.png
// module id = 115
// module chunks = 0